import scrollSpy from '@sidsbrmnn/scrollspy';
export default function initScrollSpy() {
  const options = {
    sectionSelector: 'section',  // Query selector to your sections
    targetSelector: '.nav-link', // Query selector to your elements that will be added `active` class
    offset: 100                  // Menu item will active before scroll to a matched section 100px
  }
  scrollSpy('#nav', options)



}